import type { useProctorGroups } from '@indeed/frontend-proctor-utils';

/** DQ prefill is available only in the progressive-automation treatment. */
export function isDqPrefillEnabled(
    getGroup: ReturnType<typeof useProctorGroups>['getGroup'],
): boolean {
    return (
        getGroup('rnhp_auto_apply_banner_tst')?.value === 2 &&
        getGroup('ia_dq_questions_prefill_tst')?.value === 1
    );
}
